import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function SkeletonCourseCard() {
  return (
    <Card className="overflow-hidden">
      {/* Thumbnail skeleton */}
      <Skeleton className="h-48 w-full rounded-t-lg" />
      
      <CardHeader className="space-y-3">
        {/* Title skeleton */}
        <Skeleton className="h-6 w-3/4" />
        {/* Description skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-5/6" />
        </div>
      </CardHeader>

      <CardContent className="space-y-4">
        {/* Stats skeleton */}
        <div className="flex items-center gap-6">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-16" />
        </div>
        
        {/* Instructor skeleton */}
        <Skeleton className="h-4 w-32" />
      </CardContent>

      <CardFooter className="flex items-center justify-between">
        {/* Price skeleton */}
        <Skeleton className="h-8 w-20" />
        {/* Button skeleton */}
        <Skeleton className="h-10 w-32" />
      </CardFooter>
    </Card>
  );
}

export function SkeletonCourseGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCourseCard key={i} />
      ))}
    </div>
  );
}
